export default function capitalize(value) {
  if (!value) return ''
  value = value.toLowerCase()
  value = value.trim().split(/\s+/)
  for (let i = 0; i < value.length; i++) {
    value[i] = value[i][0].toUpperCase() + value[i].substr(1);
  }
  return value.join(" ")
}